import { VotingTypes } from "interfaces/Room/VotingTypes";

export const votingTypeData = [
  {
    votingType: VotingTypes.Fibonnacci,
    text: "Fibonnacci (0, 0.5, 1, 2, 3, 5, 8, 13, 21, 34, 55, ? )"
  },
  { votingType: VotingTypes.Random, text: "random" }
];
